import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Candidato } from '../models/candidato';
import { Categoria } from '../models/categoria';
import { Comoconheceu } from '../models/comoconheceu';
import { Classificacao } from '../models/classificacao';
import { Deficiencia } from '../models/deficiencia';
import { Escolaridade } from '../models/escolaridade';
import { Estadocivil } from '../models/estadocivil';
import { Racacor } from '../models/racacor';
import { Uf } from '../models/uf';
import { DataService } from '../components/shared/services/data.service';

@Injectable()
export class InscricaoService extends DataService {

  url = this.urlApi + 'v1/inscricao/';

  constructor(private http: HttpClient) {
    super();
  }

  inserirCandidato(candidato: any) {
    return this.http.post(this.url + 'inserir', candidato)
      .catch(this.handleError);
  }

  editarCandidato(candidato) {
    candidato.dataNascimento = new Date(
      candidato.dataNascimento.substr(6, 4),
      candidato.dataNascimento.substr(3, 2) - 1,
      candidato.dataNascimento.substr(0, 2)
    );

    candidato.dataCnh = new Date(
      candidato.dataCnh.substr(6, 4),
      candidato.dataCnh.substr(3, 2) - 1,
      candidato.dataCnh.substr(0, 2)
    );

    candidato.validadeCnh = new Date(
      candidato.validadeCnh.substr(6, 4),
      candidato.validadeCnh.substr(3, 2) - 1,
      candidato.validadeCnh.substr(0, 2)
    );

    return this.http.put(this.url + 'editar', candidato)
      .catch(this.handleError);
  }

  getListaCategoria() {
    return this.http.get<Categoria[]>(this.url + 'getCategoria')
      .catch(this.handleError);
  }

  getListaComoconheceu() {
    return this.http.get<Comoconheceu[]>(this.url + 'getComoConheceu')
      .catch(this.handleError);
  }

  getListaClassificacao() {
    return this.http.get<Classificacao[]>(this.url + 'getClassificacao')
      .catch(this.handleError);
  }

  getListaDeficiencia() {
    return this.http.get<Deficiencia[]>(this.url + 'getDeficiencia')
      .catch(this.handleError);
  }

  getListaEscolaridade() {
    return this.http.get<Escolaridade[]>(this.url + 'getEscolaridade')
      .catch(this.handleError);
  }

  getListaEstadocivil() {
    return this.http.get<Estadocivil[]>(this.url + 'getEstadoCivil')
      .catch(this.handleError);
  }

  getListaRacacor() {
    return this.http.get<Racacor[]>(this.url + 'getRacaCor')
      .catch(this.handleError);
  }

  validaDados(cnpj: string, data: string, cpf: string) {
    data = data.replace('/', '').replace('/', '');
    return this.http.get(this.url + 'validaDados/' + cnpj + '/' + data + '/' + cpf)
      .catch(this.handleError);
  }

  validaDadosNova(cnpj: string, data: string, cpf: string, idFase: string, idOfertaPretendida: string) {
    data = data.replace('/', '').replace('/', '');
    return this.http.get(this.url + 'validaDadosNova/' + data + '/' + cpf + '/' + idFase + '/' + cnpj + '/' + idOfertaPretendida)
      .catch(this.handleError);
  }

  validaCnpjDeTransporte(cnpj: string) {
    return this.http.get(this.url + 'validaCnpjDeTransporte/' + cnpj)
      .catch(this.handleError);
  }

  validaCnh(data: string) {
    return this.http.get(this.url + 'validacnh/' + data.replace('-', '').replace('-', ''))
      .catch(this.handleError);
  }

  getEnderecoByCep(cep: string, iduf: string) {
    return this.http.get('https://api.sestsenat.org.br/localidades/enderecos/porCep/' + cep)
      .catch(this.handleError);
    //return this.http.get(this.url + 'getEnderecoByCep/' + cep + '/' + iduf)
      //.catch(this.handleError);
  }

  getEmpresaParticipanteUnidade(cep: string) {
    return this.http.get(this.url + 'getEmpresaParticipanteUnidade/' + cep)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/inscricao.service.ts